import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationPanel = ({ notifications = [] }) => {
  const [showAll, setShowAll] = useState(false);
  
  const displayNotifications = showAll ? notifications : notifications?.slice(0, 3);

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'rfq_update':
        return 'FileText';
      case 'order_update':
        return 'Package';
      case 'payment':
        return 'CreditCard';
      case 'promotion':
        return 'Tag';
      case 'webinar':
        return 'Calendar';
      default:
        return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'rfq_update':
        return 'text-primary';
      case 'order_update':
        return 'text-success';
      case 'payment':
        return 'text-warning';
      case 'promotion':
        return 'text-accent';
      case 'webinar':
        return 'text-secondary';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Notifications</h3>
        <Button variant="ghost" size="sm" iconName="Settings">
          Settings
        </Button>
      </div>
      {notifications?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Bell" size={32} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">No new notifications</p>
        </div>
      ) : (
        <div className="space-y-3">
          {displayNotifications?.map((notification) => (
            <div key={notification?.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-smooth">
              <div className={`mt-0.5 ${getNotificationColor(notification?.type)}`}>
                <Icon name={getNotificationIcon(notification?.type)} size={16} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground font-medium mb-1">
                  {notification?.title}
                </p>
                <p className="text-xs text-muted-foreground mb-2 line-clamp-2">
                  {notification?.message}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">
                    {formatTimeAgo(notification?.timestamp)}
                  </span>
                  {notification?.actionUrl && (
                    <Link 
                      to={notification?.actionUrl}
                      className="text-xs text-primary hover:text-primary/80 font-medium"
                    >
                      {notification?.actionText || 'View'}
                    </Link>
                  )}
                </div>
              </div>
              
              {!notification?.read && (
                <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
              )}
            </div>
          ))}
          
          {notifications?.length > 3 && (
            <div className="pt-3 border-t border-border">
              <Button 
                variant="ghost" 
                size="sm" 
                fullWidth
                onClick={() => setShowAll(!showAll)}
                iconName={showAll ? 'ChevronUp' : 'ChevronDown'}
              >
                {showAll ? 'Show Less' : `Show ${notifications?.length - 3} More`}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationPanel;